
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import ContractsPage from "@/pages/contracts/ContractsPage";
import ContractCreatePage from "@/pages/contracts/ContractCreatePage";
import ContractEditPage from "@/pages/contracts/ContractEditPage";
import ContractViewPage from "@/pages/contracts/ContractViewPage";
import ContractTimelinePage from "@/pages/contracts/ContractTimelinePage";
import QuickAddContractPage from "@/pages/contracts/QuickAddContractPage";

export function ContractRoutes() {
  return (
    <>
      <Route 
        path="/contracts" 
        element={
          <ProtectedRoute>
            <ContractsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contracts/new" 
        element={
          <ProtectedRoute>
            <ContractCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contracts/quick-add" 
        element={
          <ProtectedRoute>
            <QuickAddContractPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contracts/:id/edit" 
        element={
          <ProtectedRoute>
            <ContractEditPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contracts/:id" 
        element={
          <ProtectedRoute>
            <ContractViewPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/contracts/:id/timeline" 
        element={
          <ProtectedRoute>
            <ContractTimelinePage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
